import mixpanel from 'mixpanel-browser';
import constants from '../config.js';

var initialized = false;

function initMixpanel() {
  if (initialized) return;
  initialized = true;

  var consent = localStorage.getItem('primal_cookie_consent');
  mixpanel.init(constants.MIXPANEL);

  if (consent === 'essential') {
    mixpanel.opt_out_tracking();
  }
}

// Listen for consent changes at runtime
if (typeof window !== 'undefined') {
  window.addEventListener('cookieConsentChanged', function (e) {
    if (!initialized) return;
    if (e.detail && e.detail.consent === 'essential') {
      mixpanel.opt_out_tracking();
    } else {
      mixpanel.opt_in_tracking();
    }
  });
}

export { initMixpanel };
export default mixpanel;
